import React, { FC } from "react";
import { Box, BoxProps, Typography } from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";

const useStyles = makeStyles((theme) => ({
  inputWrapper: {
    "&:not(:last-child)": {
      marginBottom: theme.spacing(1.5),
    },
  },
  label: {
    fontSize: 14,
    fontWeight: 600,
    color: theme.palette.text.secondary,
    marginBottom: theme.spacing(0.5),
    textTransform: "uppercase",
  },
}));

export interface NutritionInputGroupProps extends BoxProps {
  label: string;
}

const NutritionInputGroup: FC<NutritionInputGroupProps> = ({
  label,
  children,
  ...other
}) => {
  const s = useStyles();

  return (
    <Box className={s.inputWrapper} {...other}>
      <Typography className={s.label}>{label}</Typography>
      {children}
    </Box>
  );
};

export default NutritionInputGroup;
